<div class="where-used-tree">
  <div class="where-used-header">
    <div class="header-icon">
      <i class="fas fa-sitemap"></i>
    </div>
    <div class="header-copy">
      <h2>{{ app.text.part.whereUsed }}</h2>
      <p>{{ app.text.part.whereUsedDescription }}</p>
    </div>
    <button class="icon-button close-button" type="button" (click)="close()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  @if (selectedPartNumber !== '' || selectedDesignation !== '') {
    <div class="info-panel">
      <div class="info-column cpn-column">
        <div class="info-label">
          {{ specialLogicLabels(app.fieldId.impact.artNumber) }}
        </div>
        <div class="info-value cpn-value">
          {{ selectedPartNumber || "-" }}
        </div>
      </div>
      <div class="info-divider"></div>
      <div class="info-column">
        <div class="info-label">
          {{ specialLogicLabels(app.fieldId.impact.omfVehicleName) }}
        </div>
        <div class="info-value designation-value">
          {{ selectedDesignation || "-" }}
        </div>
      </div>
    </div>
  }

  <div class="summary-panel">
    <div class="summary-item">
      <span class="summary-icon"><i class="fas fa-cube"></i></span>
      <span class="summary-number">{{ uniqueParentItems }}</span>
      <span class="summary-label">
        {{ app.text.part.whereUsedUniqueDirectParentItems }}
      </span>
    </div>
    <div class="summary-divider"></div>
    <div class="summary-item">
      <span class="summary-icon"><i class="fas fa-layer-group"></i></span>
      <span class="summary-number">{{ totalUsages }}</span>
      <span class="summary-label">{{ app.text.part.whereUsedTotalUsages }}</span>
    </div>
  </div>

  <div class="tree-table">
    <div
      class="tree-head"
      [style.grid-template-columns]="treeColumnsTemplate"
      >
      @for (column of columns; track column) {
        <div
          [ngClass]="getColumnClass(column)"
          >
          {{ specialLogicLabels(column) }}
        </div>
      }
    </div>

    @if (loading) {
      <div class="tree-loading">
        {{ app.text.part.whereUsedLoading }}
      </div>
    }

    @for (row of rows; track row) {
      <div
        class="tree-row"
        [style.grid-template-columns]="treeColumnsTemplate"
        >
        @for (column of columns; track column) {
          <div
            class="tree-cell"
            [ngClass]="getColumnClass(column)"
            >
            <div>
              @switch (getColumnType(column)) {
                @case ('artNumber') {
                  <div class="cpn-cell">
                    <span
                      class="tree-indent"
                      [style.width.px]="getLevel(row) * 20"
                    ></span>
                    @if (row.children.length > 0) {
                      <button
                        class="toggle-button"
                        type="button"
                        (click)="toggle(row)"
                        >
                        <i
                          [class.fa]="row.isOpen"
                          [class.far]="!row.isOpen"
                          [class.fa-minus]="row.isOpen"
                          [class.fa-plus]="!row.isOpen"
                        ></i>
                      </button>
                    }
                    @if (row.children.length === 0) {
                      <span class="toggle-spacer">
                        <i class="far fa-minus"></i>
                      </span>
                    }
                    <span class="cpn-link">{{ getColumnValue(row, column) }}</span>
                  </div>
                }
                @case ('optionText') {
                  <div>
                    {{ app.field.getOptionText(column, getColumnValue(row, column)) }}
                  </div>
                }
                @case ('decimalNumber') {
                  <div>
                    @if (getColumnValue(row, column) > -1) {
                      <span>
                        {{
                        app.field.formatNumberWithDecimals(
                        getColumnValue(row, column),
                        2
                        )
                        }}
                      </span>
                    }
                  </div>
                }
                @default {
                  <div>
                    {{ getColumnValue(row, column) || "-" }}
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    }

    @if (!loading && rows.length === 0) {
      <div class="tree-empty">
        {{ app.text.app.noResults }}
      </div>
    }
  </div>

  <div class="where-used-footer">
    <div>{{ getUniqueDirectParentItemsFooter() }}</div>
    <button class="footer-close" type="button" (click)="close()">
      {{ app.text.part.close }}
    </button>
  </div>
</div>
